import React from "react";

import { observer, inject } from "mobx-react";
import { toJS } from "mobx";

import Icon from "sulu-admin-bundle/components/Icon";
import Table from "sulu-admin-bundle/components/Table";
import MultiSelect from "sulu-admin-bundle/components/MultiSelect";
import PassportCell from "../../ui/PassportCell";
import shirt from "../../../../../svgs/Shirt";

import style from "../../styles/player.module.scss";

const Option = MultiSelect.Option;
const { Row, Cell } = Table;

const TeamPlayerRow = inject("selectionStore")(
    observer(({ selectionStore, player, index, localState, disabled }) => {
        const allPositions = toJS(selectionStore.allPositions);

        return (
            <>
                <Row>
                    <Cell>{index + 1}</Cell>
                    <Cell>
                        <input
                            disabled={disabled}
                            className={style["player-number"]}
                            style={{
                                border:
                                    !player.number || player.number == "/"
                                        ? "1px solid red"
                                        : "1px solid #ccc",
                            }}
                            type="number"
                            value={!!player.number ? player.number : ""}
                            onChange={(e) =>
                                selectionStore.setNumber(
                                    player.contact,
                                    e.target.value,
                                )
                            }
                            inputMode="numeric"
                            min="1"
                            max="99"
                        ></input>
                    </Cell>
                    <Cell>
                        <PassportCell player={player} localState={localState} />
                    </Cell>
                    <Cell>{player.name}</Cell>
                    <Cell> {shirt({ isCore: player.core, fill: null })}</Cell>
                    <Cell>
                        <input
                            disabled={disabled}
                            style={{
                                cursor: "pointer",
                            }}
                            type="checkbox"
                            checked={player.isCaptain || false}
                            onChange={() =>
                                selectionStore.setCaptain(player.contact)
                            }
                        />
                    </Cell>
                    <Cell>
                        <div
                            style={{
                                width: "10rem",
                            }}
                        >
                            <MultiSelect
                                disabled={disabled}
                                displayValue={"Choose position"}
                                name="positions"
                                values={(player.positions || []).map(
                                    (p) => p.id,
                                )}
                                onChange={(values) => {
                                    selectionStore.setPositions(
                                        player.contact,
                                        values,
                                        allPositions,
                                    );
                                }}
                            >
                                {allPositions.map((position) => (
                                    <Option
                                        key={position.id}
                                        value={position.id}
                                    >
                                        {position.name}
                                    </Option>
                                ))}
                            </MultiSelect>
                        </div>
                    </Cell>
                    <Cell>
                        {!disabled && (
                            <div
                                onClick={() => {
                                    selectionStore.removePlayer(player.contact);
                                }}
                            >
                                <Icon name="su-trash-alt" />
                            </div>
                        )}
                    </Cell>
                </Row>
            </>
        );
    }),
);

export default TeamPlayerRow;
